import { useEventListener } from ".";

export function useClickOutside(ref, callback) {
  useEventListener(
    "click",
    (e) => {
      if (ref.current == null || ref.current.contains(e.target)) return;
      // console.log('Running Hook!');
      callback(e);
    },
    document
  );
}
